import type { ReactNode, VFC } from 'react';

import classNames from 'classnames';

import * as styles from './Badge.module.scss';

export interface BadgeProps {
  label?: ReactNode;
  kind?: 'normal' | 'live';
  light?: boolean;
  contrast?: boolean;
  className?: string;
}

const Badge: VFC<BadgeProps> = ({
  label = '',
  kind = 'normal',
  light = false,
  contrast = false,
  className,
}) => {
  return (
    <span
      className={classNames(
        styles.container,
        { [styles[kind]]: kind },
        { [styles.light]: light },
        { [styles.contrast]: contrast },
        className
      )}
    >
      {label}
    </span>
  );
};

export { Badge };
